export default __webpack_public_path__ + "static/media/bm-1.6bb7f430.png";